const zIndices = {
  card: 995,
  meatBallMenu: 996,
  sidebar: 997,
  modal: 999,
  dropdown: 998
}

export default zIndices
